import React, { useState, useEffect } from 'react';
import './ScrollToTopButton.css';

const ScrollToTopButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 400);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.getElementById('main-content')?.focus({ preventScroll: true });
    };

    if (!isVisible) return null;

    return (
        <button
            className="scroll-to-top-button visible"
            onClick={scrollToTop}
            aria-label="Scroll back to top of page"
            title="Back to top"
        >
            <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
            >
                <polyline points="18 15 12 9 6 15" />
            </svg>
        </button>
    );
};

export default React.memo(ScrollToTopButton);
